"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropList = void 0;
var _DropList = require("./DropList.styles");
var _List = require("../../../../Data/List");
var _jsxRuntime = require("react/jsx-runtime");
var DropList = function DropList(props) {
  var options = props.options,
    onInputOptionSelect = props.onInputOptionSelect;
  var styles = (0, _DropList.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Input__dropList'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
      role: "listbox",
      children: options === null || options === void 0 ? void 0 : options.map(function (option) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          role: "option",
          id: option.value,
          size: "small",
          color: "basic",
          onClick: function onClick() {
            onInputOptionSelect(option);
          },
          children: option.label
        }, option.value);
      })
    })
  });
};
exports.DropList = DropList;